<template>
  <div class="main">
    <GoBack :name="`隐私条款`" :type="2" :path="`/mobile/my`"></GoBack>

    <div class="content-box">
      <div class="p-list">
        <p
          :style="`text-indent: ${cItem.indent ? '2em' : ''}; margin-bottom:${
            cItem.bottom ? '20px' : '0px'
          };`"
          v-for="(cItem, cIndex) in list"
          :key="cIndex"
          v-html="cItem.name"
        ></p>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
export default {
  data() {
    return {
      list: [
        {
          name: "尊敬的用户，请您务必仔细阅读爱答卷(以下简称“我们”)政策声明，并确定了解我们对您个人信息的处理规则。请您务必充分理解各条款内容，特别是以加粗、加下划线等形式提示您重点注意的条款。",
        },
        {
          name: "除非您已充分阅读、完全理解并接受本隐私政策所有条款，否则您无权使用我们的的产品或服务。您点击“同意”或“下一步”，或您使用我们的产品或服务，或者以其他任何明示或者默示方式表示接受本隐私政策的，均视为您已阅读并同意签署本隐私政策。本隐私政策即在您与我们之间产生法律效力，成为对双方均具有约束力的法律文件。",
        },
        {
          name: "如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读和判断是否同意本隐私政策，并特别注意未成年人使用条款。",
        },
        {
          name: "如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。",
        },
        {
          name: "爱答卷非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息。",
        },
        {
          name: "本政策将帮助您了解以下内容：",
        },
        {
          name: "1．我们如何收集您的个人信息 ",
        },
        {
          name: "2．我们如何使用 Cookie 和同类技术 ",
        },
        {
          name: "3．我们如何使用您的个人信息 ",
        },
        {
          name: "4．我们会如何共享、转让、公开披露您的个人信息",
        },
        {
          name: "5．我们如何保护和保存您的个人信息 ",
        },
        {
          name: "6．您如何管理个人信息",
        },
        {
          name: "7．未成年人信息的保护",
        },
        {
          name: "8．本政策的适用及更新",
        },
        {
          name: "9．如何联系我们 ",
        },
        {
          name: "一、我们如何收集您的个人信息",
        },
        {
          name: "个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：<strong>基本信息</strong>（包括个人姓名、生日、性别、住址、手机号码、电子邮箱）；<strong>个人身份信息</strong>（包括身份证、军官证、护照、驾驶证等）；<strong>人口学属性信息</strong>（教育程度、职业、收入以及其他市场调研行业需要收集的信息）；<strong>问卷作答信息</strong>（您在参与市场调查问卷时，需要作答问卷中的题目，您可能需要提供下述但不限于如下您的日常信息（产品认知，消费行为等等）；<strong>个人财产信息</strong>（积分、奖品、积分记录、兑换记录等信息）；<strong>个人上网记录</strong>（包括网站浏览记录、软件使用记录、点击记录）；<strong>个人常用设备信息</strong>（包括硬件型号、设备 MAC 地址、IP 地址、操作系统类型、浏览器信息、软件列表唯一设备识别码（如 IMEI、IDFA 等在内的描述个人常用设备基本情况的信息）；<strong>个人位置信息</strong>（精准定位信息、经纬度等）； ",
        },
        {
          name: "1、 您直接提供的信息 ",
        },
        {
          name: "(1)注册",
        },
        {
          name: "在您注册本软件账户或使用本软件服务时，需要提供昵称、头像、手机号码、密码、生日、性别、省份、城市。如您不提供前述信息，可能无法注册账户或无法使用本软件服务。手机号码和密码是您登陆和使用本软件的必要条件，生日、性别、省份、城市信息是您参与市场调查问卷抽样的必须条件。",
        },
        {
          name: "人口学属性信息，是您参与市场调查问卷必要的前提条件，所以除注册信息外，您还需要进一步向我们提供包括但不限于您的如下属性信息（教育程度、职业、收入以及其他市场调研行业需要收集的信息）。",
        },
        {
          name: "(2)问卷作答",
        },
        {
          name: "市场调查问卷就是用科学的方法系统地搜集、记录、整理和分析有关市场的信息资料，从而了解市场发展变化的现状和趋势，为企业经营决策、广告策划、广告写作提供科学的依据。一份比较完善的问卷作答信息通常由以下几部分构成： ",
        },
        {
          name: "a.被调查者的基本情况包括被调查者的年龄、性别、教育程度、职业、住址、收入等。 ",
        },
        {
          name: "b.调查内容本身是指所调查的具体项目，它是问卷的最重要的组成部分。",
        },
        {
          name: "c.调查问卷说明其内容主要包括填表目的和要求，被调查者注意事项，提交时间等。",
        },
        {
          name: "调查内容是用户主要填写的部分，例如：请问你使用过以下哪些品牌的牙膏？ ",
        },
        {
          name: "A 两面针 B 高露洁 C 雅植 ",
        },
        {
          name: "(3)兑换",
        },
        {
          name: "我们首先会核实您的积分合法性，比如是否存在通过作弊，盗取，冒领，重复领取等行为获得积分的情况，当发现积分有异常情况下我们有权拒绝您的兑换申请、并且扣减您非法所得的积分。",
        },
        {
          name: "1、当您使用积分兑换奖品时，根据奖品的差异，需要您提供相应的信息。首先兑换需要认证手机号码真实性，以便于通知您兑换相关信息。兑换卡券等虚拟奖品需要您提供 Email 信息， 以便您接收卡号/卡密等信息。兑换现金类奖品，需要您填写支付宝、身份证、真实姓名、且需要对身份证进行验证，因为我们需要向税务机关进行您的个人所得税申报。<strong>请您一定注意，我们向税务机关进行您的个人所得税申报会直接体现在您的个税记录中，如果您在领取低保，或者您的收入/个税记录与您的其它事项有关系，请切记谨慎操作，以免带来不必要的麻烦，我们不承担由此造成的您个人的任何损失以及任何责任。</strong>实物快递类奖品，至少需要您提供手机号码，收货人姓名，收货地址信息。 ",
        },
        {
          name: "2、自动收集的信息 ",
        },
        {
          name: "为了改进提高我们的产品和服务，同时为了更有针对性和准确的向您推送市场调研活动，以及满足市场调研的项目要求，您同意并授权我们收集您的如下信息：<strong>个人上网记录</strong>（包括网站浏览记录、软件使用记录、点击记录）；<strong>个人常用设备信息</strong>（包括硬件型号、设备 MAC 地址、IP 地址、操作系统类型、浏览器信息、软件列表唯一设备识别码（如 IMEI、IDFA 等在内的描述个人常用设备基本情况的信息）；<strong>个人位置信息</strong>（精准定位信息、经纬度等）； ",
        },
        {
          name: "3、第三方信息 ",
        },
        {
          name: "您可能通过微博、微信、QQ 支付宝等第三方帐号登录本软件，我们可能从第三方获取您授权共享的帐号信息（标识 ID、头像、昵称等），并在您同意本隐私政策后将您的第三方账户与您的本软件帐号绑定，使您可以通过第三方帐号直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。 ",
        },
        {
          name: "二、我们如何使用 Cookie 和同类技术",
        },
        {
          name: "您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。我们使用 Cookie 主要包含以下几种情况： ",
        },
        {
          name: "1、判断注册用户登录状态 ",
        },
        {
          name: "2、提升服务/产品质量，向您提供个性化需求 ",
        },
        {
          name: "3、市场调查问卷项目需求",
        },
        {
          name: "我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。",
        },
        {
          name: "三、我们如何使用您的个人信息",
        },
        {
          name: "1．使用我们的服务时用于身份验证，用户服务和安全防范等；",
        },
        {
          name: "2．个性化服务以及帮助我们设计新服务，提升现有服务体验； ",
        },
        {
          name: "3．市场调研、<strong>广告监测分析以及相关的</strong>数据研究和数据分析；",
        },
        {
          name: "4．日常运营活动；",
        },
        {
          name: "5．根据法律法规或监管要求向相关部门进行报告。",
        },
        {
          name: "四、我们会如何共享、转让、公开披露您的个人信息 ",
        },
        {
          name: "1、共享 ",
        },
        {
          name: "我们不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意， 我们可在以下情况下共享您的个人信息。",
        },
        {
          name: "（1）事先获得您明确的同意或授权；  ",
        },
        {
          name: "（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；",
        },
        {
          name: "（3）只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；",
        },
        {
          name: "（4）应您需求为您处理您与他人的纠纷或争议； ",
        },
        {
          name: "（5）基于学术研究而使用； ",
        },
        {
          name: "共享给我们的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与我们的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。",
        },
        {
          name: "我们可能会向合作伙伴等第三方共享您的某些信息，<strong>如与第三方广告监测服务商共享您的唯一设备识别码用于市场调研、广告监测分析等。</strong>我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时， 我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。 ",
        },
        {
          name: "2、转让 ",
        },
        {
          name: "我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：",
        },
        {
          name: "（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； ",
        },
        {
          name: "（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 ",
        },
        {
          name: "3、公开披露",
        },
        {
          name: "我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息 ",
        },
        {
          name: "（1）获得您的明确同意；",
        },
        {
          name: "（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求。但我们保证，在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件。",
        },
        {
          name: "五、我们如何保护和保存您的个人信息",
        },
        {
          name: "我们重视个人信息安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。",
        },
        {
          name: "我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。",
        },
        {
          name: "在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。",
        },
        {
          name: "我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。 ",
        },
        {
          name: "六、您如何管理个人信息",
        },
        {
          name: "我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。",
        },
        {
          name: "1、PC 端，登录后，在<strong>账号设置</strong>中可以修改以下三类信息：账号信息，个人资料和兑换信息。",
        },
        {
          name: "2、手机端，登录后，在<strong>我的</strong>里面可以修改各项个人信息。 ",
        },
        {
          name: "七、未成年人信息的保护",
        },
        {
          name: "1、如果您是 18 周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。 ",
        },
        {
          name: "2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。 ",
        },
        {
          name: "八、本政策的适用及更新",
        },
        {
          name: "本产品所有服务均适用政策明。",
        },
        {
          name: "发生下列重大变化情形时，我们会适时对本政策进行更新： ",
        },
        {
          name: " （1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；",
        },
        {
          name: "（2）收集、存储、使用个人信息的范围、目的、规则发生变化； ",
        },
        {
          name: "（3）对外提供个人信息的对象、范围、目的发生变化； ",
        },
        {
          name: "（4）您访问和管理个人信息的方式发生变化； ",
        },
        {
          name: "（5）数据安全能力、信息安全风险发生变化； ",
        },
        {
          name: "（6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化； ",
        },
        {
          name: "（7）其他可能对您的个人信息权益产生重大影响的变化。 ",
        },
        {
          name: "对于政策明发生重大变化，我们会通过不同渠道向您发送变更通知，包括但不限于网站公示、私信通知、App 推送等方式。 ",
        },
        {
          name: "九、如何联系我们",
        },
        {
          name: "当您对本政策有任何疑问，可以发送邮件至team#baishulai.com咨询（请将#号替换成@符号），我们将及时解决您的问题。 ",
        },
        {
          name: "<small>注：本《隐私政策》版本于2019年1月1日生效。</small>",
        },
      ],
      active: null,
    };
  },
  components: { GoBack },
  methods: {
    changeActive(index) {
      if (index === this.active) {
        this.active = null;
      } else {
        this.active = index;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8fa;
  .content-box {
    width: calc(100% - 30px);
    margin-left: 15px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    overflow: hidden;
    margin-bottom: 12px;
    transition: max-height ease 0.75s;
    .p-list {
      padding: 10px 9px;
      color: #232323;
      font-size: 14px;
      line-height: 20px;
      p {
        margin-bottom: 10px !important;
        color: #333;
        font-size: 14px;
      }
    }
  }
}
</style>
<style scoped>
p>>>strong{
    font-weight: bold !important;
}
</style>